import { ALERT_PROVIDER_TOKEN, IAlertProvider } from '@addins/core/core';
import { UnitSelectorService } from '@addins/core/unit-activity';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActionSheetButton } from '@ionic/angular';
import { MyEquipmentService } from '@techwan/ionic-core';
import { UnitActivity } from '@techwan/ionic-core/lib/schema/imported/SagaSchema/UnitActivity';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit, OnDestroy {
  private _canCreateAlert: boolean = false;
  get canCreateAlert(): boolean {
    return this._canCreateAlert;
  }

  private _loadingText: string;
  get loadingText(): string {
    return this._loadingText;
  }

  get unitCreationButtons(): ActionSheetButton[] {
    return this._unitSelectorService.unitCreationButtons;
  }

  private subs: Subscription[] = [];

  constructor(
    @Inject(ALERT_PROVIDER_TOKEN)
    private _alertProvider: IAlertProvider,
    private _myEquipment: MyEquipmentService,
    private _unitSelectorService: UnitSelectorService
  ) {}

  ngOnInit() {
    this.subs.push(this._myEquipment.$myUnit.subscribe(unitActivity => this.onUnitActivityChanged(unitActivity)));
    this.subs.push(this._alertProvider.canCreate().subscribe(canCreateAlert => (this._canCreateAlert = canCreateAlert)));
  }

  ngOnDestroy() {
    while (this.subs.length > 0) {
      this.subs.pop().unsubscribe();
    }
  }

  private onUnitActivityChanged(unitActivity: UnitActivity) {
    const noUnit: boolean = unitActivity === null;
    this._loadingText = noUnit ? 'SagaMobile.WaitingForAUnit' : 'loading...';
  }
}
